<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["data-fullscreen", "data-touched", "data-playing", "data-paused", "data-waiting", "data-muted", "data-idle", "data-hover", "data-standalone"];
const _hoisted_2 = { class: "magic-player-video-controls__bar" };
const _hoisted_3 = { class: "magic-player-video-controls__item -shrink-0" };
const _hoisted_4 = { class: "magic-player-video-controls__item -grow" };
const _hoisted_5 = { class: "magic-player-video-controls__item -shrink-0" };
const _hoisted_6 = { class: "magic-player-video-controls__item -shrink-0" };
import { ref, computed, inject, provide } from "vue";
import { useIdle } from "@vueuse/core";
import IconPlay from "./icons/Play.vue";
import IconPause from "./icons/Pause.vue";
import IconVolumeOn from "./icons/VolumeOn.vue";
import IconVolumeOff from "./icons/VolumeOff.vue";
import IconFullscreenEnter from "./icons/FullscreenEnter.vue";
import IconFullscreenExit from "./icons/FullscreenExit.vue";
import { usePlayerMediaApi } from "../composables/private/usePlayerMediaApi";
import { usePlayerVideoApi } from "../composables/private/usePlayerVideoApi";
import { usePlayerControlsApi } from "../composables/private/usePlayerControlsApi";
import { MagicPlayerInstanceId, MagicPlayerOptionsKey } from "../symbols";
import "@maas/vue-equipment/utils/css/animations/fade-up-in.css";
import "@maas/vue-equipment/utils/css/animations/fade-up-out.css";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicPlayerVideoControls",
  props: {
    id: { type: String, required: false },
    standalone: { type: Boolean, required: false, default: false },
    transition: { type: String, required: false }
  },
  setup(__props) {
    const instanceId = inject(MagicPlayerInstanceId, void 0);
    const mappedId = computed(() => __props.id ?? instanceId);
    if (!mappedId.value) {
      throw new Error(
        "MagicPlayerVideoControls must be nested inside MagicPlayerProvider or be passed an id as a prop."
      );
    }
    const injectedOptions = inject(MagicPlayerOptionsKey, void 0);
    const mappedTransition = computed(
      () => __props.transition ?? injectedOptions?.transition?.videoControls
    );
    const barRef = ref(void 0);
    const trackRef = ref(void 0);
    const popoverRef = ref(void 0);
    const { playing, waiting, muted } = usePlayerMediaApi({
      id: mappedId.value
    });
    const {
      touched,
      mouseEntered,
      isFullscreen,
      play,
      pause,
      mute,
      unmute,
      enterFullscreen,
      exitFullscreen
    } = usePlayerVideoApi({ id: mappedId.value });
    const { popoverOffsetX, seekedTime } = usePlayerControlsApi({
      id: mappedId.value,
      barRef,
      trackRef,
      popoverRef
    });
    const { idle } = useIdle(3e3);
    const hidden = computed(() => {
      switch (true) {
        case __props.standalone:
          return false;
        case (playing.value && idle.value):
          return true;
        case (playing.value && !mouseEntered.value):
          return true;
        case !touched.value:
          return true;
        default:
          return false;
      }
    });
    provide(MagicPlayerInstanceId, mappedId.value);
    return (_ctx, _cache) => {
      const _component_magic_player_timeline = _resolveComponent("magic-player-timeline");
      return _openBlock(), _createElementBlock("div", {
        class: "magic-player-video-controls",
        "data-fullscreen": _unref(isFullscreen),
        "data-touched": _unref(touched),
        "data-playing": _unref(playing),
        "data-paused": !_unref(playing),
        "data-waiting": _unref(waiting),
        "data-muted": _unref(muted),
        "data-idle": _unref(idle),
        "data-hover": _unref(mouseEntered),
        "data-standalone": _ctx.standalone
      }, [
        _createVNode(_Transition, {
          name: mappedTransition.value,
          persisted: ""
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode(
              "div",
              _hoisted_2,
              [
                _ctx.$slots.popover ? _withDirectives((_openBlock(), _createElementBlock(
                  "div",
                  {
                    key: 0,
                    ref_key: "popoverRef",
                    ref: popoverRef,
                    class: "magic-player-video-controls__popover",
                    style: _normalizeStyle({ marginLeft: `${_unref(popoverOffsetX)}%` })
                  },
                  [
                    _renderSlot(_ctx.$slots, "popover")
                  ],
                  4
                  /* STYLE */
                )), [
                  [_vShow, !!_unref(seekedTime) && _unref(touched)]
                ]) : _createCommentVNode("v-if", true),
                _createElementVNode(
                  "div",
                  {
                    ref_key: "barRef",
                    ref: barRef,
                    class: "magic-player-video-controls__bar--inner"
                  },
                  [
                    _createElementVNode("div", _hoisted_3, [
                      !_unref(playing) ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = //@ts-ignore
                        (...args) => _unref(play) && _unref(play)(...args))
                      }, [
                        _renderSlot(_ctx.$slots, "playIcon", {}, () => [
                          _createVNode(IconPlay)
                        ])
                      ])) : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = //@ts-ignore
                        (...args) => _unref(pause) && _unref(pause)(...args))
                      }, [
                        _renderSlot(_ctx.$slots, "pauseIcon", {}, () => [
                          _createVNode(IconPause)
                        ])
                      ]))
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _renderSlot(_ctx.$slots, "timelineBefore"),
                      _createElementVNode(
                        "div",
                        {
                          ref_key: "trackRef",
                          ref: trackRef,
                          class: "magic-player-video-controls__timeline"
                        },
                        [
                          _createVNode(_component_magic_player_timeline)
                        ],
                        512
                        /* NEED_PATCH */
                      ),
                      _renderSlot(_ctx.$slots, "timelineAfter")
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _unref(muted) ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = //@ts-ignore
                        (...args) => _unref(unmute) && _unref(unmute)(...args))
                      }, [
                        _renderSlot(_ctx.$slots, "volumeOffIcon", {}, () => [
                          _createVNode(IconVolumeOff)
                        ])
                      ])) : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[3] || (_cache[3] = //@ts-ignore
                        (...args) => _unref(mute) && _unref(mute)(...args))
                      }, [
                        _renderSlot(_ctx.$slots, "volumeOnIcon", {}, () => [
                          _createVNode(IconVolumeOn)
                        ])
                      ]))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _unref(isFullscreen) ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[4] || (_cache[4] = //@ts-ignore
                        (...args) => _unref(exitFullscreen) && _unref(exitFullscreen)(...args))
                      }, [
                        _renderSlot(_ctx.$slots, "fullscreenExitIcon", {}, () => [
                          _createVNode(IconFullscreenExit)
                        ])
                      ])) : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[5] || (_cache[5] = //@ts-ignore
                        (...args) => _unref(enterFullscreen) && _unref(enterFullscreen)(...args))
                      }, [
                        _renderSlot(_ctx.$slots, "fullscreenEnterIcon", {}, () => [
                          _createVNode(IconFullscreenEnter)
                        ])
                      ]))
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                )
              ],
              512
              /* NEED_PATCH */
            ), [
              [_vShow, !hidden.value]
            ])
          ]),
          _: 3
          /* FORWARDED */
        }, 8, ["name"])
      ], 8, _hoisted_1);
    };
  }
});
</script>
